module.exports = __webpack_public_path__ + "img/star-badge.1117f80e.png";